<template>
    <div class="d-inline">
        <button @click.prev.prevent="exportExcel(url)" class="btn btn-sm" :disabled="!!disabled" :class="button_class" target="_blank">
            <i class="far fa-file-excel" :title="$t('Export as Excel')"></i> {{ button_text ? button_text : 'Excel' }}
        </button>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        props: [
            'url',
            'button_class',
            'button_text',
            'price_option',
            'production_time_option',
            'disabled'
        ],

        data() {
            return {
                display_price_option: this.price_option === undefined ? true : this.price_option,
                display_production_time_option: this.production_time_option === undefined ? true : this.production_time_option,
                display_price_in_export: false,
                display_production_time_in_export: false,
                display_purchase_price_in_export: false,
            }
        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),

            export_checkbox_html() {
                let html = '';
                if (this.$can('view_prices') && this.display_price_option) {
                    html += `<div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="display_price">
                                <label className="form-check-label" htmlFor="display_price">` + this.$t('Display prices') + `</label>
                            </div>`;
                }

                if (this.$can('view_production_time') && this.display_production_time_option) {
                    html += `<div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="" id="display_production_time">
                                        <label className="form-check-label" htmlFor="display_production_time">` + this.$t('Display production time') + `</label>
                                </div>`;
                }

                return html;
            },
        },

        methods: {
            exportExcel(url) {

                this.$swal.fire({
                    title: this.$t('Export as Excel'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3CA2A4',
                    cancelButtonColor: '#393e42',
                    confirmButtonText: this.$t('Download'),
                    cancelButtonText: this.$t('Cancel'),
                    html: this.export_checkbox_html,
                    focusConfirm: false,
                    preConfirm: () => {
                        this.display_price_in_export = document.getElementById('display_price') ? document.getElementById('display_price').checked : false;
                        this.display_production_time_in_export = document.getElementById('display_production_time') ? document.getElementById('display_production_time').checked : false;
                    }
                }).then((result) => {

                    if (result && result.isConfirmed) {
                        let language = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'de';
                        window.open(this.url + '?display_price=' + this.display_price_in_export + '&display_production_time=' + this.display_production_time_in_export + '&lang=' + language, '_blank');
                    }

                    this.display_price_in_export = false;
                    this.display_production_time_in_export = false;
                })
            },

        }
    }
</script>
